var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImpresionsFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 17,
    viewBox: "0 0 8 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8 5.50507H5.27636V3.74187C5.27636 3.07752 5.72 2.92311 6.03273 2.92311C6.34545 2.92311 7.95636 2.92311 7.95636 2.92311V0.0107732L5.30909 0C2.37091 0 1.70182 2.17258 1.70182 3.56232V5.50507H0V8.50718H1.69818C1.69818 12.3604 1.69818 17 1.69818 17H5.27273C5.27273 17 5.27273 12.3137 5.27273 8.50718H7.68364L8 5.50507Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImpresionsFacebook);
export default __webpack_public_path__ + "static/media/impresions_facebook.981d548ea5e5ff8f5e7b5e055e5ba5f9.svg";
export { ForwardRef as ReactComponent };